import React from 'react';

import { Add } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import CenteredGrid from 'components/CenteredGrid/CenteredGrid';
import ColoredButton from 'components/ColoredButton';
import action_library_messages from 'messages/action_library_messages';

import useStyles from './ActionTemplateStepsActions.styles';

type ActionTemplateStepsActionsProps = {
  onAddStep: () => void;
  onCancel: () => void;
  loading: boolean;
  showChecklistError: boolean;
  isEditMode: boolean;
  onSaveAndContinue?: () => void;
};

const ActionTemplateStepsActions: React.FC<ActionTemplateStepsActionsProps> = ({
  onAddStep,
  onCancel,
  loading,
  showChecklistError,
  isEditMode = false,
  onSaveAndContinue,
}) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <CenteredGrid className={styles.stickyContainer} width='lg' withoutPadding>
      <div className={styles.actionsContainer}>
        <ColoredButton
          className={showChecklistError ? styles.addStepButtonError : styles.addStepButton}
          customColor='secondary'
          disabled={false}
          icon={false}
          onClick={onAddStep}
          showLoader={false}
          startIcon={<Add />}
          textLike={false}
          variant='outlined'
        >
          {t(action_library_messages.steps.add_step)}
        </ColoredButton>
        {isEditMode && (
          <ColoredButton
            className=''
            customColor='grey'
            disabled={loading}
            icon={false}
            onClick={onCancel}
            showLoader={false}
            textLike={false}
            variant='outlined'
          >
            {t(action_library_messages.steps.cancel)}
          </ColoredButton>
        )}
        <ColoredButton
          className=''
          customColor='secondary'
          disabled={loading}
          icon={false}
          onClick={onSaveAndContinue}
          showLoader={loading}
          textLike={false}
          variant='outlined'
        >
          {t(action_library_messages.steps.save_template)}
        </ColoredButton>
        <ColoredButton
          className=''
          customColor='secondary'
          disabled={loading}
          icon={false}
          showLoader={loading}
          textLike={false}
          type='submit'
          variant='outlined'
        >
          {t(action_library_messages.steps.update_template)}
        </ColoredButton>
      </div>
    </CenteredGrid>
  );
};

export default ActionTemplateStepsActions;
